import { Component, OnInit, Input, ElementRef } from '@angular/core';

import { ParallaxBackgroundService } from './parallax-background.service';

@Component({
    selector: 'finder-parallax-background',
    templateUrl: './parallax-background.component.html',
    styleUrls: ['./parallax-background.component.scss'],
    standalone: true,
})
export class ParallaxBackgroundComponent implements OnInit {
    @Input() theme;
    @Input() data;

    constructor(
        private parallaxBgService: ParallaxBackgroundService,
        private elementRef: ElementRef,
    ) { }

    ngOnInit() {
        this.parallaxBgService.data = this.data;
        this.parallaxBgService.createTheme(this.theme, this.elementRef);
    }
}
